<template>
  <div class="content">
    <div class="pro-mobile">
      <menu-mobile />
    </div>
    <div class="back-row-frame">
      <div class="v-c-left">
        <div
          ref="point_type"
          class="mall-dropdown"
          :class="{ active: isActive }"
          @click.stop="toggleDropdown"
        >
          <button class="dropbtn">
            {{ $t('Bao.member_bonus') }}
            <i class="dropbtn-arr" />
          </button>
          <div class="dropdown-content">
            <a @click.prevent>{{ $t('Bao.member_bonus') }}</a>
            <a v-if="isFreeSpin" @click="$router.push('/points/free-spin')">{{ $t('Bao.free_spin') }}</a>
          </div>
        </div>
      </div>
      <div class="v-c-right">
        <div class="exchange-amount-frame">
          <div class="token-name">
            <span>{{ $t('Bao.point_name') }}</span>
          </div>
          <div class="token-amount">
            <span>{{ mainPoint | numberFormatThird }}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="view-card mall-min-h">
      <div v-if="!allProd" class="history-list-content if-no-data">
        <div class="no-data">
          <i>
            <img :src="require(`@/assets/${$store.getters.currentTheme}/images/no-data.png`)" alt="">
          </i>
          <p>{{ $t('Bao.no_relevant_data_records') }}</p>
          <span>{{ $t('Bao.search_results_are_empty') }}</span>
        </div>
      </div>
      <div v-else class="view-card-body ticket-list">
        <div
          v-for="prod in allProd"
          :key="prod.id"
          class="ticket-frame"
          @click="showModel(prod)"
        >
          <div class="tf-left">
            <div class="bonus-cube">
              <div class="amount">
                {{ prod.setting.income }}
              </div>
              <div class="unit">
                {{ $t('Bao.point_unit') }}
              </div>
            </div>
          </div>
          <div class="tf-right">
            <div class="title">
              {{ $t('Bao.point_reward') }}{{ prod.amount }}
            </div>
            <div class="describe">
              {{ $t('Bao.point_amount', {amount: prod.amount}) }}
            </div>
            <div class="second-half">
              <div class="describe">
                <div class="des-end">
                  VIP {{ prod.vip.map(v => v.replace('VIP', '')).join('/') }}
                </div>
              </div>
              <div>
                <a v-if="prod.availBuy" class="btn btn-exchange">{{ $t('Bao.redeem') }}</a>
                <a v-else class="btn btn-exchange lock">
                  <img :src="require(`@/assets/${$store.getters.currentTheme}/images/icon-lock.png`)" alt="">
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <confirm-purchase-modal
        :is-active="showModal"
        :selected-prod="selectedProd"
        :quantity="quantity"
        @update-quantity="updateQuantity"
        @hideModel="hideModel"
      />
    </div>
  </div>
</template>
<script>
import { detectMob, refreshGold } from '@/utils/tool'
import { showNotice } from '@/utils/tool'
import { getAllProductInfo, purchaseProd, prodStatus } from '@/api/shop'
import confirmPurchaseModal from '@/components/modal/confirmPurchaseModal'
import menuMobile from '@/components/shop/menuMobile'

export default {
  components: {
    confirmPurchaseModal,
    menuMobile
  },
  data() {
    return {
      allProd: [],
      showModal: false,
      limitText: '',
      selectedProd: {},
      quantity: 1,
      isActive: false,
      isFreeSpin: false
    }
  },
  computed: {
    mainPoint() {
      const storeMainPoint = this.$store.getters.mainPoint
      if (!isNaN(storeMainPoint)) {
        return storeMainPoint
      } else {
        return this.$store.state.user.memberInfo.main_points
      }
    }
  },
  watch: {
    '$store.state.user.isConfirmPurchase': function(newVal) {
      if (newVal) {
        this.buyProd(this.selectedProd)
        this.$store.commit('SET_SHOP_PURCHASE', false)
      }
    }
  },
  created() {
    this.$store.commit('SET_SHOP_PURCHASE', false)
    this.getAllProd()
  },
  mounted() {
    document.addEventListener('click', this.handleClickOutside)
  },
  beforeDestroy() {
    document.removeEventListener('click', this.handleClickOutside)
  },
  methods: {
    handleClickOutside(event) {
      const point_type = this.$refs.point_type
      if (this.isActive && point_type && !point_type.contains(event.target)) {
        this.isActive = false
      }
    },
    toggleDropdown() {
      this.isActive = !this.isActive
    },
    updateQuantity(newQuantity) {
      this.quantity = newQuantity
    },
    getAllProd() {
      getAllProductInfo().then((response) => {
        if (response.data.data.data.play_n_go_free_play || response.data.data.data.PragmatciPlayFreeSpin) {
          this.isFreeSpin = true
        }

        const currentVipIndex = this.$store.state.user.vipInfo.currentVipName
        const currentVip = parseInt(currentVipIndex.replace('VIP', ''))
        const finalCurrentlVip = isNaN(currentVip) ? 'lite player' : currentVip

        this.allProd = response.data.data.data.turnover_bonus_package
        if (this.allProd) {
          Promise.all(this.allProd.map(prod => {
            const requiredVip = prod.vip
            const vipNumbers = requiredVip.map(vipQual => parseInt(vipQual.replace('VIP', '')))
            const finalVipNumbers = vipNumbers.map(num => (isNaN(num) ? 'lite player' : num))
            let vipQual = false

            if (finalCurrentlVip === 'lite player') {
              if (finalVipNumbers[0] === 'lite player') {
                vipQual = true
              }
            } else if (finalCurrentlVip >= finalVipNumbers[0]) {
              vipQual = true
            }

            return prodStatus({ id: prod.id, sub_id: prod.sub_id }).then(statusResponse => {
              const statusText = this.handlePurchaseResponse(statusResponse.data.status, false)
              return { ...prod,
                status: statusResponse.data.status,
                statusText: statusText,
                name: prod.setting.income + this.$t('Bao.point_unit_2'),
                type: 1,
                type_name: this.$t('Bao.point_type_membership'),
                availBuy: statusResponse.data.status === 200 && Math.floor(Number(this.mainPoint)) >= prod.amount && vipQual
              }
            })
          }))
            .then(updatedProducts => {
              this.allProd = updatedProducts
              refreshGold()
            })
            .catch(error => {
              this.allProd = null
              showNotice(error.response.data.msg)
            })
        }
      })
    },
    handlePurchaseResponse(status, showNoticeFlag) {
      let message
      if (status === 200) {
        message = this.$t('Bao.purchase_success')
      } else if (status === 201) {
        message = this.$t('Bao.discrepancy_level')
      } else if (status === 202) {
        message = this.$t('Bao.sold_out')
      } else if (status === 203 || status === 204 || status === 207) {
        message = this.$t('Bao.not_enough_points')
      } else {
        message = this.$t('Bao.unavailable_1') + status + this.$t('Bao.unavailable_2')
      }

      if (showNoticeFlag) {
        showNotice(message)
      } else {
        return message
      }
    },
    buyProd(prod) {
      purchaseProd({ id: prod.id, sub_id: prod.sub_id, count: this.quantity }).then((response) => {
        this.handlePurchaseResponse(response.status, true)
        this.getAllProd()
        this.quantity = 1
      }).catch((error) => {
        showNotice(error.response.data.msg)
      })
    },
    showModel(prod) {
      this.selectedProd = prod
      this.limitText = this.$t('Bao.confirm_purchase')
      this.showModal = true
    },
    hideModel() {
      this.showModal = false
    },
    isMobile() {
      return detectMob()
    }
  }
}
</script>

<style scoped>

</style>
